import { useEffect } from 'react';
import { useBffApiRequest } from '@/hooks/useBffApiRequest';
import { BffStaticTextContentResponse, CmsStaticTextContentType } from '@lucky7ventures/bff-types';
import BffApiService from '@/shared/bffApiService';
import { useSelector } from 'react-redux';
import { selectLocale } from '@/store/selectors/commonSelectors';
import { euTerms } from '@/constants/constants';

export const useTermsAndConditionsLoader = () => {
  const locale = useSelector(selectLocale);
  const { request, data, loading } = useBffApiRequest<BffStaticTextContentResponse>();

  useEffect(() => {
    if (locale !== 'eu') {
      request({
        apiMethod: BffApiService.getStaticTextContent,
        axiosConfig: { params: { contentType: CmsStaticTextContentType.termsAndConditions } },
      });
    }
  }, [locale]);

  if (locale === 'eu') {
    return { tcData: { title: 'Terms And Conditions', content: euTerms }, tcLoading: false };
  }

  return { tcData: data, tcLoading: loading };
};
